import axios from 'axios';
import { state } from '@/store';

const configHeaders = {
  headers: {
    'Access-Control-Allow-Origin': '*',
    'content-type': 'application/x-www-form-urlencoded',
    Accept: 'application/json',
  },
};

export default class Axios {
  loggedHeaders = () => ({
    headers: {
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
      Authorization: `Bearer ${state.user.token}`,
    },
  });

  getHeaders = () => {
    if (state.user) {
      return this.loggedHeaders();
    }
    return configHeaders;
  }

  makeCall = (method, url, data = null) => {
    const axiosParameters = {
      method,
      url: `${process.env.VUE_APP_API_HOST}/${url}`,
      headers: this.getHeaders().headers,
    };

    const formData = new FormData();
    if (method !== 'GET' && method !== 'DELETE') {
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
      }
      formData.append('_method', method);
      axiosParameters.data = formData;
    }

    if (method !== 'GET') {
      axiosParameters.method = 'POST';
    }
    if (method === 'DELETE') {
      formData.append('_method', 'DELETE');
      axiosParameters.data = formData;
    }
    if (method === 'PUT') {
      formData.append('_method', 'PUT');
    }
    return new Promise((resolve, reject) => {
      axios(axiosParameters)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  };
}
